module.exports = __webpack_public_path__ + "img/what-we-do-icon-2.7255baf2.svg";